import type { ReactNode } from 'react'
import { Icon } from '@/components/Icon'
import { Spinner } from '@/components/Spinner'
import { IconVisual } from '@/components/IconVisual'
import {
  BillingItemList,
  BillingItem,
  BillingItemVisual,
  BillingItemContent,
  BillingItemTitle,
  BillingItemSubtitle,
  BillingItemExtras,
  BillingItemBadge,
} from '@/features/billing/components/BillingItemList'

interface CouponListProps {
  children?: ReactNode
}

/**
 * The CouponList
 */
export function CouponList({ children }: CouponListProps) {
  return <BillingItemList>{children}</BillingItemList>
}

interface CouponListItemProps {
  friendlyName: string
  code: string
  description: string
  selected?: boolean
  onPress?: () => unknown
  isPending?: boolean
  isDisabled?: boolean
  testId?: string
}

/**
 * Coupon List Item
 */
export function CouponListItem({
  friendlyName,
  code,
  description,
  selected,
  onPress,
  isDisabled,
  isPending,
  testId,
}: CouponListItemProps) {
  return (
    <BillingItem
      isCurrent={selected}
      onPress={onPress}
      isDisabled={isDisabled}
      testId={testId}
    >
      <BillingItemVisual>
        <IconVisual>
          <Icon size={36} name="coupons" />
        </IconVisual>
      </BillingItemVisual>
      <BillingItemContent>
        <BillingItemTitle>{friendlyName}</BillingItemTitle>
        <BillingItemSubtitle>
          {code}
          {description && <> | {description}</>}
        </BillingItemSubtitle>
      </BillingItemContent>
      <BillingItemExtras>
        {selected && <BillingItemBadge>Current</BillingItemBadge>}
        {isPending && <Spinner />}
      </BillingItemExtras>
    </BillingItem>
  )
}
